import MenuItem, { ButtonContainer } from "@components/MenuItem"
import animation, { cubicBezier } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import * as R from "ramda"
import React from "react"
import styled from "styled-components"

import {
  BreadcrumbButton,
  DesktopDivider,
  DesktopHeader,
  Headers,
} from "./common"

const openProps = `
  transform: translateX(0);
  transition: transform ${animation.medium} ${cubicBezier};
`
const Container = styled.div<{ $isOpen?: boolean }>`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 1;
  transform: translateX(100%);
  transition: transform ${animation.medium} ${cubicBezier};
  will-change: transform;
  background-color: ${colors.offWhite};
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 3;
  cursor: default;
  ${({ $isOpen }) => ($isOpen ? openProps : "")}
`

const overlayActiveProps = `
  opacity: 0.1
  transition: opacity ${animation.medium} ${cubicBezier};
`
const Overlay = styled.div<{ $isVisible: boolean }>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  will-change: opacity;
  opacity: 0;
  transition: opacity ${animation.kindaLong} ${cubicBezier};
  background-color: ${colors.black};
  pointer-events: none;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 3;
  ${({ $isVisible }) => ($isVisible ? overlayActiveProps : "")}
`

const Languages = styled.div`
  overflow: hidden;

  ${ButtonContainer} {
    color: ${colors.black};

    svg {
      stroke: ${colors.black};
    }
  }

  @media ${breakpoints.laptop} {
    padding: 0 calc(0.5 / 12 * 100vw);

    ${ButtonContainer} {
      height: 64px;
      padding: 0 6px 0 16px;
    }
  }
`

export interface LanguageProps {
  language: string
  onClick: () => void
}

interface LanguageSelectorProps {
  isOpen?: boolean
  languages: Array<LanguageProps>
  onRequestClose: () => void
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  isOpen,
  languages = [],
  onRequestClose,
}) => {
  const handleClose = (e) => {
    e.stopPropagation()
    onRequestClose()
  }

  const formattedItems = R.map(({ language, onClick }) => ({
    label: language,
    onClick,
  }))(languages)

  return (
    <>
      <Overlay $isVisible={!!isOpen} />
      <Container $isOpen={!!isOpen}>
        <Headers>
          <BreadcrumbButton label="Back" onClick={handleClose} />
        </Headers>
        <DesktopHeader>All Languages</DesktopHeader>
        <Languages>
          <DesktopDivider />
          {formattedItems.map((props) => (
            <MenuItem key={props.label} {...props} />
          ))}
        </Languages>
      </Container>
    </>
  )
}

export default LanguageSelector
